import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AttributionIcon(props: IconProps) {
    return <Icon {...props} iconKey={"attribution"}/>
}
